import React from 'react';
import '../../WorldDbEmptyStart.css';

const IconMail = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <rect x="2" y="4" width="20" height="16" rx="2.5" stroke="currentColor" strokeWidth="2" />
    <path d="M3 7l9 6 9-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const IconSend = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M22 2L11 13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path d="M22 2l-7 20-4-9-9-4 20-7z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const IconInbox = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M22 12h-6l-2 3H10l-2-3H2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M5.45 5.11L2 12v6a2 2 0 002 2h16a2 2 0 002-2v-6l-3.45-6.89A2 2 0 0016.76 4H7.24a2 2 0 00-1.79 1.11z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const InboxEmptyStart = ({
  onConnectAccount,
  canWrite = true,
}) => (
  <div className="wdEmpty wdEmpty--inbox">
    <div className="wdEmpty-panel">
      <div className="wdEmpty-hero">
        <span className="wdEmpty-badge" aria-hidden="true">
          <IconMail />
        </span>
        <p className="wdEmpty-eyebrow">Inbox</p>
        <h2 className="wdEmpty-title wdEmpty-title--static">
          Connect your <span className="wdEmpty-swap">inbox</span>
        </h2>
        <p className="wdEmpty-lead">
          Nothing arrives here until an email account is linked. Add one in
          Settings and this inbox starts filling.
        </p>
      </div>

      <div className="wdEmpty-grid">
        <button
          type="button"
          className="wdEmpty-card wdEmpty-card--primary"
          onClick={onConnectAccount}
          disabled={!canWrite}
        >
          <span className="wdEmpty-cardIcon wdEmpty-cardIcon--import">
            <IconMail />
          </span>
          <span className="wdEmpty-cardBody">
            <span className="wdEmpty-cardTitle">Connect an account</span>
            <span className="wdEmpty-cardText">
              Gmail, Outlook or any IMAP mailbox. Host and login, then you are live.
            </span>
          </span>
          <span className="altBtn altBtn--save wdEmpty-cardBtn">Open settings</span>
        </button>

        <button
          type="button"
          className="wdEmpty-card"
          onClick={onConnectAccount}
          disabled={!canWrite}
        >
          <span className="wdEmpty-cardIcon wdEmpty-cardIcon--create">
            <IconSend />
          </span>
          <span className="wdEmpty-cardBody">
            <span className="wdEmpty-cardTitle">Send from here</span>
            <span className="wdEmpty-cardText">
              Outreach uses this address as the sender. One mailbox is enough to start.
            </span>
          </span>
          <span className="altBtn altBtn--petrol wdEmpty-cardBtn">Add mailbox</span>
        </button>

        <button
          type="button"
          className="wdEmpty-card"
          onClick={onConnectAccount}
          disabled={!canWrite}
        >
          <span className="wdEmpty-cardIcon wdEmpty-cardIcon--api">
            <IconInbox />
          </span>
          <span className="wdEmpty-cardBody">
            <span className="wdEmpty-cardTitle">Replies land here</span>
            <span className="wdEmpty-cardText">
              Incoming mail shows up in this inbox on its own. No extra setup after connect.
            </span>
          </span>
          <span className="altBtn altBtn--petrol wdEmpty-cardBtn">Get started</span>
        </button>
      </div>

      {!canWrite && (
        <p className="wdEmpty-readonly">
          This workspace is read-only. Ask the owner to connect a mailbox.
        </p>
      )}
    </div>
  </div>
);

export default InboxEmptyStart;
